module.exports = __webpack_public_path__ + "img/chivas-21-nam-royal-salute-190.148182bd.jpg";